import React from "react";
import { yen, num, pct } from "@/lib/format";
import { useI18n } from "@/context/I18nContext";

const TONE = {
  default: "text-[#0A0A0A]",
  brand: "text-brand",
  green: "text-emerald-600",
  red: "text-red-600",
  amber: "text-amber-600",
};

export function StatCard({ label, value, unit, format = "num", tone = "default", icon: Icon, onClick, testid, hint }) {
  const { t } = useI18n();
  const display = format === "yen" ? yen(value) : format === "pct" ? pct(value) : num(value);
  return (
    <button
      onClick={onClick}
      className={`text-left bg-white border border-border rounded-sm p-4 md:p-5 transition-colors hover:border-brand/60 hover:bg-gray-50/50 group ${onClick ? "cursor-pointer" : "cursor-default"}`}
      data-testid={testid}
    >
      <div className="flex items-start justify-between mb-3">
        <span className="text-[10px] md:text-xs uppercase tracking-[0.08em] font-medium text-muted-foreground">{t(label)}</span>
        {Icon && <Icon className="w-4 h-4 text-gray-300 group-hover:text-brand transition-colors" />}
      </div>
      <div className="flex items-baseline gap-1.5">
        <span className={`font-display text-3xl md:text-4xl font-light tracking-tight ${TONE[tone]}`}>{display}</span>
        {unit && <span className="text-sm text-muted-foreground">{t(unit)}</span>}
      </div>
      {hint && <div className="text-xs text-muted-foreground mt-1.5">{hint}</div>}
    </button>
  );
}
